/*@ngInject*/
const UpdateUserPreferencesRepository = function (baseRepository, $cacheFactory) {

    let cache = $cacheFactory.get('preferenceRepository'),
        cacheKey = 'userPrefs';

    angular.extend(this, baseRepository);

    if (!cache) {
        cache = $cacheFactory('preferenceRepository', {capacity: 10});
    }

    this.updateUserPreferences = function (data) {
        let url = '/rest/UserPreference';

        return this.post(url, data).then(function (responseData) {
            let cachedData = cache.get(cacheKey);
            if (cachedData) {
                cachedData = _.assign(cachedData, data);

                cache.put(cacheKey, cachedData);
            }

            return responseData;
        });
    };
};

angular.module('umCore')
    .service('updateUserPreferencesRepository', UpdateUserPreferencesRepository);
